// tutorial https://marmelab.com/react-admin/doc/3.8/Tutorial.html
// naming conventions de react-admin (.js en vez de .jsx) y de https://stackoverflow.com/questions/43973199/file-naming-conventions-in-reactjs
// usamos named exports: https://dmitripavlutin.com/javascript-modules-best-practices/
// creamos los indices con: ls -1a *.js | grep -v index.js | xargs -i echo "export * from './{}'" > index.js
// ejemplo de imports:
//   import { PerfilCreate, PerfilList } from './perfil';
//   import * as Perfil from './perfil'
//   (Perfil.PerfilCreate)

import React from 'react';
import { Admin, Resource } from 'react-admin';
import jsonServerProvider from 'ra-data-json-server';
import authProvider from './authProvider';
import { authProviderHttpClient } from './authProvider'
import { i18nProvider } from './i18n/i18nProvider';
import { LoginPage } from './auth';
import Theme from "./themes/theme";
import Layout from './layout/Layout';
import { routes } from "./routes";
const dataProvider = jsonServerProvider("/api/thea/data", authProviderHttpClient);

const App = () => (
  <Admin 
    theme={Theme()} 
    dataProvider={dataProvider} 
    authProvider={authProvider} 
    i18nProvider={i18nProvider} 
    loginPage={LoginPage} 
    layout={Layout} 
    customRoutes={routes}
  >
    {/* quitamos home si queremos que entre directamente en un recurso o lo mantenemos y editamos routes/HomePage.js */}
    <Resource name="home"/>
  </Admin>
);

export default App;
